import { render, staticRenderFns } from "./Learn__Section--SymmClovers.vue?vue&type=template&id=5a9b3dd4&lang=pug&"
import script from "./Learn__Section--SymmClovers.vue?vue&type=script&lang=js&"
export * from "./Learn__Section--SymmClovers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports